<script>
import ElProgress from 'element-ui/lib/progress'
import { getThemeColor } from '@/utils/theme'

export default {
  name: 'ElProgress',
  extends: ElProgress,
  props: {
    defineBackColor: {
      ...ElProgress.props.defineBackColor,
      default: 'var(--ui-bg-control-elevated)'
    },
    textColor: {
      ...ElProgress.props.textColor,
      default: 'var(--ui-text-regular)'
    }
  },
  computed: {
    stroke () {
      return this.getCurrentColor(this.percentage)
    }
  },
  methods: {
    getCurrentColor (percentage) {
      // 显式传入的颜色函数、分段数组或业务色仍使用 Element 的处理规则。
      if (this.color) return ElProgress.methods.getCurrentColor.call(this, percentage)
      const tone = this.status === 'exception' ? 'danger' : this.status === 'warning' ? 'warning' : 'primary'
      return getThemeColor(tone) || `var(--ui-color-${tone})`
    }
  },
  render (h) {
    const vnode = ElProgress.render.call(this, h)
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-progress']
    return vnode
  }
}
</script>
